import React from 'react';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function BeforeAfterSection() {
  const before = ['Clases preparadas a último momento', 'Horas creando material desde cero', 'Falta de organización durante el año', 'Dificultad para seguir un plan claro'];
  const after = ['Clases listas para usar en minutos', 'Material organizado para todo el año', 'Planificación clara y sin estrés', 'Más tiempo y control en tus clases'];
  return <section className="py-12 px-6 bg-[#0f0f23]" data-id="element-16">
      <div className="grid grid-cols-2 gap-3" data-id="element-17">
        {/* Before */}
        <div className="bg-red-500/5 border border-red-500/20 rounded-2xl p-4" data-id="element-18">
          <p className="text-red-400 font-black text-sm uppercase tracking-wide mb-4 text-center" data-id="element-19">
            ❌ Antes
          </p>
          <div className="space-y-3" data-id="element-20">
            {before.map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-21">
                <XCircle className="w-4 h-4 text-red-500 shrink-0 mt-0.5" data-id="element-22" />
                <span className="text-gray-300 text-[11px] leading-snug" data-id="element-23">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        {/* After */}
        <div className="bg-green-500/5 border border-green-500/20 rounded-2xl p-4" data-id="element-24">
          <p className="text-green-400 font-black text-sm uppercase tracking-wide mb-4 text-center" data-id="element-25">
            ✔ Después
          </p>
          <div className="space-y-3" data-id="element-26">
            {after.map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-27">
                <CheckCircle2 className="w-4 h-4 text-green-400 shrink-0 mt-0.5" data-id="element-28" />
                <span className="text-gray-300 text-[11px] leading-snug" data-id="element-29">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}